import { DefaultService } from '../../common/services/DefaultService';
import * as $ from 'jquery';
import { apiBaseUrlUser } from '../../../constants/url.constant';
import {
    AccountConfirmModel, AccountPhoneModel, ChangePasswordModel, EmailForgotPasswordModel,
    LoginModel, ResetPasswordModel, SignupModel, TokenResource
} from '../models/AccountTypes';

export class AccountService extends DefaultService {
    private baseUrl = `${apiBaseUrlUser}/account`

    public RouteLogout = () => `${this.baseUrl}/logout`;
    public logout(): JQueryPromise<any> {
        return $.ajax(this.RouteLogout(), {
            type: 'get',
            contentType: 'text/html; charset=utf-8'
        });
    }

    public RouteLogin = () => `${this.baseUrl}/login`;
    public login(model: LoginModel): JQueryPromise<any> {
        //result: AuthTokenInfo
        return $.ajax(this.RouteLogin(), {
            type: 'post',
            data: JSON.stringify(model),
            contentType: 'application/json'
        });
    }

    public RouteSignup = () => `${this.baseUrl}/signup`;
    public signup(model: SignupModel): JQueryPromise<any> {
        //result: AccountModel
        return $.ajax(this.RouteSignup(), {
            type: 'post',
            data: JSON.stringify(model),
            contentType: 'application/json'
        });
    }

    public RouteResetPassword = () => `${this.baseUrl}/resetPassword`;
    public resetPassword(model: ResetPasswordModel): JQueryPromise<any> {
        //result: AuthTokenInfo
        return $.ajax(this.RouteResetPassword(), {
            type: 'post',
            data: JSON.stringify(model),
            contentType: 'application/json'
        });
    }

    public RouteChangePassword = () => `${this.baseUrl}/changePassword`;
    public changePassword(model: ChangePasswordModel): JQueryPromise<any> {
        //result: string
        return $.ajax(this.RouteChangePassword(), {
            type: 'post',
            data: JSON.stringify(model),
            contentType: 'application/json'
        });
    }

    public RouteUpdateFcmToken = () => `${this.baseUrl}/updateFcmToken`;
    public updateFcmToken(model: TokenResource): JQueryPromise<any> {
        //result: string
        return $.ajax(this.RouteUpdateFcmToken(), {
            type: 'post',
            data: JSON.stringify(model),
            contentType: 'application/json'
        });
    }

    public RouteUpdateFcmTokenForGuest = () => `${this.baseUrl}/updateFcmTokenForGuest`;
    public updateFcmTokenForGuest(model: TokenResource): JQueryPromise<any> {
        //result: string
        return $.ajax(this.RouteUpdateFcmTokenForGuest(), {
            type: 'post',
            data: JSON.stringify(model),
            contentType: 'application/json'
        });
    }

    public RouteSubscribeNotificationTopic = () => `${this.baseUrl}/subscribeNotificationTopic`;
    public subscribeNotificationTopic(model: TokenResource): JQueryPromise<any> {
        //result: boolean
        return $.ajax(this.RouteSubscribeNotificationTopic(), {
            type: 'post',
            data: JSON.stringify(model),
            contentType: 'application/json'
        });
    }
}

export class AccountByService extends DefaultService {
    private baseUrl: string;

    constructor(isByEmail: boolean) {
        super();

        const controller = isByEmail ? "accountByEmail" : "accountByPhone";
        this.baseUrl = `${apiBaseUrlUser}/${controller}`;
    }

    public RouteSendConfirmCode = (userId: string) => `${this.baseUrl}/SendConfirmCode/${userId}`;
    public SendConfirmCode(userId: string): JQueryPromise<any> {
        //result: string
        return $.ajax(this.RouteSendConfirmCode(userId), {
            type: 'post',
            data: undefined,
            contentType: 'application/json'
        });
    }

    public RouteConfirm = () => `${this.baseUrl}/confirm`;
    public confirm(model: AccountConfirmModel): JQueryPromise<any> {
        //result: AuthTokenInfo
        return $.ajax(this.RouteConfirm(), {
            type: 'post',
            data: JSON.stringify(model),
            contentType: 'application/json'
        });
    }

    public RouteSendForgotPasswordCode = (userId: string) => `${this.baseUrl}/sendForgotPasswordCode/${userId}`;
    public sendForgotPasswordCode(userId: string): JQueryPromise<any> {
        //result: string
        alert(this.RouteSendForgotPasswordCode(userId));
        return $.ajax(this.RouteSendForgotPasswordCode(userId), {
            type: 'post',
            data: undefined,
            contentType: 'application/json'
        });
    }

    public RouteConfirmForgotPassword = () => `${this.baseUrl}/confirmForgotPassword`;
    public confirmForgotPassword(model: AccountConfirmModel): JQueryPromise<any> {
        //result: ResetPasswordModel
        return $.ajax(this.RouteConfirmForgotPassword(), {
            type: 'post',
            data: JSON.stringify(model),
            contentType: 'application/json'
        });
    }

    public RouteGetUserForConfirm = () => `${this.baseUrl}/getUserForConfirm`;
    public getUserForConfirm(model: AccountPhoneModel | EmailForgotPasswordModel): JQueryPromise<any> {
        //result: AccountModel
        return $.ajax(this.RouteGetUserForConfirm(), {
            type: 'post',
            data: JSON.stringify(model),
            contentType: 'application/json'
        });
    }
}